import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import * as notificationActions from 'store/notification/actions';
import useInterval from 'use-interval';
import Alert from '@material-ui/lab/Alert';
import styles from './styles.module.scss';

const Notification = () => {
  const notificationSelector = useSelector(
    (state: ApplicationState) => state.notification,
  );
  const dispatch = useDispatch();

  const displayNotificationMessage = () => {
    let message = '';
    for (
      let i = 0;
      i < notificationSelector.data.newRecordInsuranceTypes?.length;
      i++
    ) {
      if (message !== '') {
        message += ', ';
      }
      if (notificationSelector.data.newRecordInsuranceTypes[i] === 1) {
        message += '自動車';
      } else if (
        notificationSelector.data.newRecordInsuranceTypes[i] === 2
      ) {
        message += '火災';
      } else if (
        notificationSelector.data.newRecordInsuranceTypes[i] === 3
      ) {
        message += '傷害';
      }
    }
    return message;
  };

  useInterval(() => {
    const params = {
      responseStatus: ['1'],
    };
    dispatch(notificationActions.fetchRequest(params));
  }, 60000);

  return (
    notificationSelector.data.newRecordInsuranceTypes.length !== 0 && (
      <Alert className={styles.root} severity="error">
        新着の申請情報があります　保険種目：
        {displayNotificationMessage()}
      </Alert>
    )
  );
};

export default Notification;
